// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product--v2025{padding-bottom:16.25rem}.product__blocks--v2025 .slice--video{padding:0}.product__blocks--v2025 .slice--title h2{text-align:left}.product__blocks--v2025 .slice--title+.block--impact-fairly{margin-top:calc(var(--spacing)*-2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
